/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {useIntl} from 'react-intl'

import {EN_OFFER_LINK, EN_POLICY_LINK, RU_OFFER_LINK, RU_POLICY_LINK} from '@app/constants/links'

import {useLang} from '@_metronic/i18n/Metronici18n'

const BACKGROUND_URL = require('@assets/backgrounds/tst-bg.webp')

const AuthLayout = () => {
  const intl = useIntl()
  const language = useLang()

  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
      {/* begin::Body */}
      <div className='d-flex flex-column w-lg-40 p-10 order-2 order-lg-1 h-100' style={{ minWidth: 0 }}>
        {/* begin::Form */}
        <div className='d-flex flex-center flex-column flex-grow-1'>
          {/* begin::Wrapper */}
          <div className='w-100' style={{ maxWidth: '500px' }}>
            <Outlet />
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Form */}

        {/* begin::Footer */}
        <div className='d-flex flex-center flex-wrap px-5 mt-auto pt-5'>
          {/* begin::Links */}
          <div className='d-flex fw-semibold text-primary fs-base'>
            <a
              href={language === 'ru' ? RU_POLICY_LINK : EN_POLICY_LINK}
              className='px-5'
              target='_blank'
              rel='noreferrer'
            >
              {intl.formatMessage({id: 'FOOTER.CONFID'})}
            </a>

            <a
              href={language === 'ru' ? RU_OFFER_LINK : EN_OFFER_LINK}
              className='px-5'
              target='_blank'
              rel='noreferrer'
            >
              {intl.formatMessage({id: 'FOOTER.OFERTA'})}
            </a>

            <a
              href='https://jivo.chat/mm2JHN2QIJ'
              className='px-5'
              target='_blank'
              rel='noreferrer'
            >
              {intl.formatMessage({id: 'FOOTER.SUPPORT'})}
            </a>
          </div>
          {/* end::Links */}
        </div>
        {/* end::Footer */}
      </div>
      {/* end::Body */}

      {/* begin::Aside */}
      <div
        className='d-none d-lg-flex flex-lg-row-fluid w-lg-60 bgi-size-cover bgi-position-center order-1 order-lg-2'
        style={{backgroundImage: `url(${BACKGROUND_URL})`}}
      >
      </div>
      {/* end::Aside */}
    </div>
  )
}

export {AuthLayout}
